import { useState, useMemo } from "react";

const STATUT_C = {"in-progress":"#5b6ef8","en_cours":"#5b6ef8","pending":"#f5a623","planifiee":"#f5a623","brouillon":"#8899bb","completed":"#22d3a0","terminee":"#22d3a0","cancelled":"#ef4444","annulee":"#ef4444"};
const STATUT_L = {"in-progress":"En cours","en_cours":"En cours","pending":"Planifié","planifiee":"Planifié","brouillon":"Brouillon","completed":"Terminé","terminee":"Terminé","cancelled":"Annulé","annulee":"Annulé"};
const PRIO_C   = {critique:"#ef4444",urgente:"#ef4444",haute:"#f5a623",normale:"#5b6ef8",basse:"#22d3a0"};
const PRIO_O   = {critique:0,urgente:0,haute:1,normale:2,basse:3};
const STATUT_O = {"in-progress":0,"en_cours":0,"pending":1,"planifiee":1,"brouillon":2,"completed":3,"terminee":3,"cancelled":4,"annulee":4};

function getDateSection(d) {
  if (!d) return "Sans date";
  const dt = new Date(d);
  const today = new Date(); today.setHours(0,0,0,0);
  const diff = Math.floor((new Date(dt.getFullYear(),dt.getMonth(),dt.getDate()) - today) / 86400000);
  if (diff < -30) return "Il y a plus d'un mois";
  if (diff < -7)  return "La semaine dernière";
  if (diff < 0)   return "Cette semaine passée";
  if (diff === 0) return "Aujourd'hui";
  if (diff === 1) return "Demain";
  if (diff <= 7)  return "Cette semaine";
  if (diff <= 14) return "Semaine prochaine";
  if (diff <= 31) return "Ce mois-ci";
  return "Planifié plus tard";
}

const SEC_ORDER = ["Aujourd'hui","Demain","Cette semaine","Semaine prochaine","Ce mois-ci","Planifié plus tard","Cette semaine passée","La semaine dernière","Il y a plus d'un mois","Sans date"];
const SEC_C = {"Aujourd'hui":"#5b6ef8","Demain":"#f5a623","Cette semaine":"#22d3a0","Semaine prochaine":"#a855f7","Ce mois-ci":"#14b8a6","Planifié plus tard":"#8899bb","Cette semaine passée":"#8899bb","La semaine dernière":"#8899bb","Il y a plus d'un mois":"#8899bb","Sans date":"#8899bb"};

function IntCard({ i, T, onClick }) {
  const color  = STATUT_C[i.statut]||T.muted;
  const pcolor = PRIO_C[i.priorite]||T.muted;
  const dateAffiche = i.date_planifiee || i.date_intervention;
  const isToday = dateAffiche && new Date(dateAffiche).toDateString()===new Date().toDateString();
  const elapsedMin = i.started_at ? Math.floor((Date.now()-new Date(i.started_at).getTime())/60000) : null;

  return (
    <div onClick={onClick}
      style={{background:T.card,border:`1.5px solid ${T.border}`,borderRadius:14,padding:"13px 16px",display:"flex",alignItems:"center",gap:12,cursor:"pointer",transition:"all 0.12s"}}
      onMouseEnter={e=>{e.currentTarget.style.borderColor=color;e.currentTarget.style.transform="translateX(3px)";}}
      onMouseLeave={e=>{e.currentTarget.style.borderColor=T.border;e.currentTarget.style.transform="none";}}>
      <div style={{width:4,minHeight:48,borderRadius:2,background:color,flexShrink:0,alignSelf:"stretch"}}/>
      <div style={{flex:1,minWidth:0}}>
        <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:5,flexWrap:"wrap"}}>
          <span style={{fontSize:14,fontWeight:700,color:T.text}}>{i.titre}</span>
          {i.reference&&<span style={{fontSize:10,color:T.muted,fontFamily:"monospace",background:T.bg,padding:"1px 6px",borderRadius:16,border:`1px solid ${T.border}`}}>{i.reference}</span>}
          <span style={{fontSize:10,fontWeight:700,color,background:`${color}20`,padding:"2px 8px",borderRadius:20,textTransform:"uppercase"}}>{STATUT_L[i.statut]||i.statut}</span>
          <span style={{fontSize:10,fontWeight:700,color:pcolor,background:`${pcolor}18`,padding:"2px 8px",borderRadius:20}}>{i.priorite}</span>
          {elapsedMin!==null&&<span style={{fontSize:10,color:"#5b6ef8",background:"#5b6ef815",padding:"2px 8px",borderRadius:20,fontWeight:600}}>⏱ {elapsedMin}min</span>}
        </div>
        <div style={{fontSize:12,color:T.muted,display:"flex",gap:12,flexWrap:"wrap"}}>
          <span>👤 {i.client_nom||"—"}</span>
          <span>📍 {i.client_ville||i.client_adresse||"—"}</span>
          {dateAffiche&&<span style={{color:isToday?"#f5a623":T.muted,fontWeight:isToday?700:400}}>
            🕐 {new Date(dateAffiche).toLocaleDateString("fr-FR",{weekday:"short",day:"2-digit",month:"short",year:"numeric"})}
          </span>}
        </div>
      </div>
      <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:5,flexShrink:0}}>
        {i.technicien_nom ? (
          <div style={{display:"flex",alignItems:"center",gap:6}}>
            <div style={{width:26,height:26,borderRadius:"50%",background:`${T.accent}22`,border:`1.5px solid ${T.accent}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:9,fontWeight:800,color:T.accent}}>
              {i.technicien_nom.split(" ").map(n=>n[0]).join("").slice(0,2).toUpperCase()}
            </div>
            <span style={{fontSize:11,color:T.muted}}>{i.technicien_nom}</span>
          </div>
        ) : (
          <span style={{fontSize:11,color:"#f5a623",fontWeight:700}}>⚠ Non assigné</span>
        )}
      </div>
    </div>
  );
}

export default function IntListView({ T, interventions=[], onSelect, onNew }) {
  const [search, setSearch]       = useState("");
  const [statut, setStatut]       = useState("all");
  const [triPar, setTriPar]       = useState("date");
  const [ordre, setOrdre]         = useState("asc");
  const [techFilter, setTech]     = useState("all");
  const [groupDate, setGroupDate] = useState(true);
  const [collapsed, setCollapsed] = useState({});

  const techs = useMemo(()=>[...new Set(interventions.map(i=>i.technicien_nom).filter(Boolean))],[interventions]);

  const filtered = useMemo(()=>{
    let list = [...interventions];
    if (search) {
      const s = search.toLowerCase();
      list = list.filter(i=>(i.titre+i.client_nom+i.client_ville+i.reference).toLowerCase().includes(s));
    }
    if (statut!=="all") {
      const map = {en_cours:["en_cours","in-progress"],planifiee:["planifiee","pending"],terminee:["terminee","completed"],annulee:["annulee","cancelled"]};
      list = list.filter(i=>(map[statut]||[statut]).includes(i.statut));
    }
    if (techFilter!=="all") list = list.filter(i=>i.technicien_nom===techFilter);
    list.sort((a,b)=>{
      let va,vb;
      if (triPar==="date") { va=new Date(a.date_planifiee||a.date_intervention||a.created_at||0).getTime(); vb=new Date(b.date_planifiee||b.date_intervention||b.created_at||0).getTime(); }
      else if (triPar==="statut") { va=STATUT_O[a.statut]??9; vb=STATUT_O[b.statut]??9; }
      else if (triPar==="priorite") { va=PRIO_O[a.priorite]??9; vb=PRIO_O[b.priorite]??9; }
      else if (triPar==="client") { va=(a.client_nom||"").toLowerCase(); vb=(b.client_nom||"").toLowerCase(); }
      else if (triPar==="created") { va=new Date(a.created_at||0).getTime(); vb=new Date(b.created_at||0).getTime(); }
      const cmp = typeof va==="string"?va.localeCompare(vb):va-vb;
      return ordre==="asc"?cmp:-cmp;
    });
    return list;
  },[interventions,search,statut,techFilter,triPar,ordre]);

  const grouped = useMemo(()=>{
    if (!groupDate||triPar!=="date") return null;
    const groups = {};
    filtered.forEach(i=>{
      const sec = getDateSection(i.date_planifiee||i.date_intervention);
      if (!groups[sec]) groups[sec]=[];
      groups[sec].push(i);
    });
    return SEC_ORDER.filter(s=>groups[s]).map(s=>({label:s,items:groups[s]}));
  },[filtered,groupDate,triPar]);

  const toggleSection = (l) => setCollapsed(p=>({...p,[l]:!p[l]}));

  const counts = {
    all:interventions.length,
    en_cours:interventions.filter(i=>["en_cours","in-progress"].includes(i.statut)).length,
    planifiee:interventions.filter(i=>["planifiee","pending"].includes(i.statut)).length,
    terminee:interventions.filter(i=>["terminee","completed"].includes(i.statut)).length,
    annulee:interventions.filter(i=>["annulee","cancelled"].includes(i.statut)).length,
  };

  return (
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div>
          <div style={{fontSize:25,fontWeight:800,color:T.text,letterSpacing:"-0.7px"}}>🔧 Interventions</div>
          <div style={{fontSize:13,color:T.muted,marginTop:4}}>{filtered.length} / {interventions.length} intervention(s)</div>
        </div>
        <button onClick={onNew} style={{padding:"10px 20px",borderRadius:13,background:`linear-gradient(135deg,${T.accent},${T.purple})`,border:"none",color:"#fff",fontSize:14,fontWeight:700,cursor:"pointer"}}>
          ＋ Nouvelle
        </button>
      </div>

      {/* Filtres statut */}
      <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
        {[["all","Toutes",counts.all,"#5b6ef8"],["en_cours","⚙️ En cours",counts.en_cours,"#5b6ef8"],["planifiee","📅 Planifiées",counts.planifiee,"#f5a623"],["terminee","✅ Terminées",counts.terminee,"#22d3a0"],["annulee","❌ Annulées",counts.annulee,"#ef4444"]].map(([k,l,n,col])=>(
          <button key={k} onClick={()=>setStatut(k)}
            style={{padding:"7px 14px",borderRadius:20,border:`1.5px solid ${statut===k?col:T.border}`,background:statut===k?`${col}18`:"transparent",color:statut===k?col:T.muted,fontSize:12,fontWeight:statut===k?700:500,cursor:"pointer",display:"flex",alignItems:"center",gap:6,transition:"all 0.15s"}}>
            {l}<span style={{fontSize:10,background:statut===k?col:"#aaa",color:"#fff",borderRadius:20,padding:"1px 6px",fontWeight:700}}>{n}</span>
          </button>
        ))}
      </div>

      {/* Barre outils */}
      <div style={{display:"flex",gap:10,flexWrap:"wrap",alignItems:"center"}}>
        <div style={{display:"flex",alignItems:"center",gap:8,background:T.card,border:`1px solid ${T.border}`,borderRadius:12,padding:"8px 13px",flex:1,minWidth:200}}>
          <span style={{color:T.muted}}>🔍</span>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Titre, client, ville, référence..."
            style={{background:"none",border:"none",outline:"none",color:T.text,fontSize:13,flex:1}}/>
          {search&&<button onClick={()=>setSearch("")} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:16}}>✕</button>}
        </div>
        <select value={triPar} onChange={e=>{setTriPar(e.target.value);setGroupDate(e.target.value==="date");}}
          style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:9,padding:"8px 12px",color:T.text,fontSize:13,outline:"none",cursor:"pointer"}}>
          <option value="date">📅 Date planifiée</option>
          <option value="created">🕐 Date création</option>
          <option value="statut">● Statut</option>
          <option value="priorite">🔺 Priorité</option>
          <option value="client">👤 Client</option>
        </select>
        <button onClick={()=>setOrdre(o=>o==="asc"?"desc":"asc")}
          style={{padding:"8px 12px",borderRadius:9,background:T.card,border:`1px solid ${T.border}`,color:T.muted,fontSize:16,cursor:"pointer",fontWeight:700,minWidth:38}}>
          {ordre==="asc"?"↑":"↓"}
        </button>
        {triPar==="date"&&(
          <button onClick={()=>setGroupDate(g=>!g)}
            style={{padding:"8px 12px",borderRadius:9,background:groupDate?T.accentDim:T.card,border:`1px solid ${groupDate?T.accent:T.border}`,color:groupDate?T.accent:T.muted,fontSize:12,fontWeight:groupDate?700:500,cursor:"pointer",whiteSpace:"nowrap"}}>
            📂 {groupDate?"Sections actives":"Grouper"}
          </button>
        )}
        {techs.length>0&&(
          <select value={techFilter} onChange={e=>setTech(e.target.value)}
            style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:9,padding:"8px 12px",color:T.text,fontSize:13,outline:"none",cursor:"pointer"}}>
            <option value="all">👥 Tous</option>
            {techs.map(t=><option key={t} value={t}>{t}</option>)}
          </select>
        )}
      </div>

      {/* Résultats */}
      {filtered.length===0 ? (
        <div style={{textAlign:"center",padding:60,color:T.muted}}>
          <div style={{fontSize:36,marginBottom:10}}>🔍</div>
          <div style={{fontSize:14,fontWeight:700,color:T.text,marginBottom:6}}>Aucun résultat</div>
          <div style={{fontSize:13}}>Modifiez vos filtres</div>
        </div>
      ) : grouped ? (
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          {grouped.map(({label,items})=>{
            const sc = SEC_C[label]||T.muted;
            const isCollapsed = collapsed[label];
            return(
              <div key={label}>
                <div onClick={()=>toggleSection(label)}
                  style={{display:"flex",alignItems:"center",gap:10,marginBottom:8,cursor:"pointer",userSelect:"none"}}>
                  <div style={{height:1,width:12,background:`${sc}60`,flexShrink:0}}/>
                  <span style={{fontSize:13,fontWeight:700,color:sc,whiteSpace:"nowrap"}}>{label}</span>
                  <span style={{fontSize:11,background:`${sc}20`,color:sc,padding:"2px 9px",borderRadius:20,fontWeight:700}}>{items.length}</span>
                  <div style={{flex:1,height:1,background:`${sc}30`}}/>
                  <span style={{color:T.muted,fontSize:12,transform:isCollapsed?"rotate(-90deg)":"none",transition:"transform 0.2s"}}>▼</span>
                </div>
                {!isCollapsed&&(
                  <div style={{display:"flex",flexDirection:"column",gap:7}}>
                    {items.map(i=><IntCard key={i.id} i={i} T={T} onClick={()=>onSelect(i)}/>)}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <div style={{display:"flex",flexDirection:"column",gap:7}}>
          {filtered.map(i=><IntCard key={i.id} i={i} T={T} onClick={()=>onSelect(i)}/>)}
        </div>
      )}
    </div>
  );
}
